
import RequestRegisterBrandList from "@/views/RequestRegisterBrand/RequestRegisterBrandList";
import RequestRegisterBrandEdit from "@/views/RequestRegisterBrand/RequestRegisterBrandEdit";


const routes = [
 {
    path: '/RequestRegisterBrand/List',
    name: 'RequestRegisterBrandList',
    component: RequestRegisterBrandList,
    meta:{requiredAuth:true}
  },
 {
    path: '/RequestRegisterBrand/Edit/:id',
    name: 'RequestRegisterBrandEdit',
    component: RequestRegisterBrandEdit,
    meta:{requiredAuth:true}
  },
]

export default routes